import angular from 'angular';
import constants from 'app/constants';
import {
  oversightDataService,
  oversightSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
/* import attachFindingDialog from '../dialog.saveFindingConfirmDialog/attachFindingDialog';
import editFindingCommentDialog from '../dialog.editFindingCommentDialog';
import editFindingDialog from '../dialog.editFindingDialog'; */
import controller from './item-content.controller';
import directive from './item-content.directive';
import agendaItemComment from '../agendaItemComment';
import agendaItemDocument from '../agendaItemDocument';
import agendaItemReport from '../agendaItemReport';


export default angular.module('app.components.advisory.oversight.itemContent', [
  alerts,
  oversightDataService,
  oversightSharedModelService,
  // attachFindingDialog,
  confirmDialog,
  constants,
  docDataService,
  // editFindingCommentDialog,
  // editFindingDialog,
  agendaItemComment,
  agendaItemDocument,
  agendaItemReport,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('itemContent', directive)
  .controller('ItemContentController', controller)
  .name;

console.log('app.components.advisory.oversight.itemContent created');
